import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandShortcut,
  CommandSeparator,
} from "@/components/ui/command";
import { DialogTitle, DialogDescription } from "@/components/ui/dialog";
import {
  LayoutDashboard,
  Briefcase,
  Workflow,
  FileSearch,
  MapPin,
  Share2,
  Globe,
  Inbox,
  CalendarClock,
  Kanban,
  Sparkles,
  Send,
  Zap,
  Plus,
} from "lucide-react";

const NAV_ITEMS = [
  { to: "/",          label: "Overview Dashboard", icon: LayoutDashboard, shortcut: "G O" },
  // { to: "/freelance", label: "Freelance Finder",   icon: Briefcase,       shortcut: "G 1" },
  { to: "/leads",     label: "Lead Engine",        icon: Workflow,        shortcut: "G 2" },
  { to: "/rfp",       label: "RFP Intelligence",   icon: FileSearch,      shortcut: "G 3" },
  { to: "/lead-finder", label: "Lead Finder",      icon: MapPin,          shortcut: "G 4" },
  // { to: "/social",    label: "Social Automation",  icon: Share2,          shortcut: "G 5" },
  { to: "/website",   label: "Website Intel",      icon: Globe,           shortcut: "G 6" },
  { to: "/email",     label: "Email Intel",        icon: Inbox,           shortcut: "G 7" },
  { to: "/meetings",  label: "Meetings Intel",     icon: CalendarClock,   shortcut: "G 8" },
  { to: "/crm",       label: "Unified CRM",        icon: Kanban,          shortcut: "G C" },
];

const ACTIONS = [
  { label: "New AI Proposal",         icon: Sparkles, shortcut: "N P" },
  { label: "Launch Outreach Campaign", icon: Send,     shortcut: "N C" },
  { label: "Run Workflow Now",         icon: Zap,      shortcut: "R W" },
  { label: "Add Lead to CRM",          icon: Plus,     shortcut: "N L" },
];

export default function CommandPalette({ open, onOpenChange }) {
  const navigate = useNavigate();
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle className="sr-only">Command Palette</DialogTitle>
      <DialogDescription className="sr-only">
        Search across modules and run actions
      </DialogDescription>
      <div data-testid="command-palette">
        <CommandInput
          data-testid="command-palette-input"
          placeholder="Type a command, jump to a module, or ask the AI…"
        />
        <CommandList>
          <CommandEmpty>No results. Try &quot;proposals&quot; or &quot;RFP&quot;.</CommandEmpty>
          <CommandGroup heading="Navigate">
            {NAV_ITEMS.map(({ to, label, icon: Icon, shortcut }) => (
              <CommandItem
                key={to}
                data-testid={`cmd-nav-${to.replace(/\//g, "") || "home"}`}
                onSelect={() => {
                  navigate(to);
                  onOpenChange(false);
                }}
              >
                <Icon className="text-indigo-300" />
                <span>{label}</span>
                <CommandShortcut className="font-mono">{shortcut}</CommandShortcut>
              </CommandItem>
            ))}
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Actions">
            {ACTIONS.map(({ label, icon: Icon, shortcut }) => (
              <CommandItem
                key={label}
                data-testid={`cmd-action-${label.toLowerCase().replace(/\s+/g, "-")}`}
                onSelect={() => onOpenChange(false)}
              >
                <Icon className="text-cyan-300" />
                <span>{label}</span>
                <CommandShortcut className="font-mono">{shortcut}</CommandShortcut>
              </CommandItem>
            ))}
          </CommandGroup>
        </CommandList>
      </div>
    </CommandDialog>
  );
}
